module.exports = __webpack_public_path__ + "static/media/iconSave.ac5c5f11.svg";